import { render, staticRenderFns } from "./SaveToAttributeDialog.vue?vue&type=template&id=cf012bda"
import script from "./SaveToAttributeDialog.vue?vue&type=script&lang=ts"
export * from "./SaveToAttributeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports